export default __webpack_public_path__ + "static/media/grandma5.c3a853a2.jpg";